module.exports = "#updateStatus .modal-header .close {\n    position: absolute;\n    right: 10px;\n    top: 20px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    color: red;\n    font-size: 16px;\n}\n\na:hover {\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./client/app/internal/accmgr/examinee-request-details/examinee-request-details.component.css
// module id = ./client/app/internal/accmgr/examinee-request-details/examinee-request-details.component.css
// module chunks = main